import {clientAlderaan} from '../../core/stores';
import {MUTATION_ALDERAAN_ACCOUNT_USER} from '../../core/graphql/types';
import {AccountUser} from './QueryAccountUsers';

export interface NewAccountUser {
  email: string;
  name?: string;
  lastName?: string;
  rule?: string;
}

export function MutationAccountUser(
  accountId: string | number,
  user: NewAccountUser,
): Promise<AccountUser> {
  return clientAlderaan
    .mutate({
      mutation: MUTATION_ALDERAAN_ACCOUNT_USER,
      variables: {
        accountId: String(accountId),
        email: user.email,
        name: user.name,
        lastName: user.lastName,
        rule: user.rule,
      },
    })
    .then(({data}) => data?.createAccountUser?.accountUser)
    .catch((err) => {
      const message = err?.graphQLErrors?.map((error: any) => error.message).join(',');
      throw new Error(message || 'Não foi possível vincular o usuário à conta');
    });
}
